exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-link {\n    padding : 5px;\n}\n\n.active {\n    border-radius: 5px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/qrcode/static_stamp/modal/style.css
// module id = ../../../../../src/app/pages/admin/qrcode/static_stamp/modal/style.css
// module chunks = 3